import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 3.33331C7.84518 3.33331 8.125 3.61314 8.125 3.95831V16.0416C8.125 16.3868 7.84518 16.6666 7.5 16.6666C7.15482 16.6666 6.875 16.3868 6.875 16.0416V3.95831C6.875 3.61314 7.15482 3.33331 7.5 3.33331ZM12.5 3.33331C12.8452 3.33331 13.125 3.61314 13.125 3.95831V16.0416C13.125 16.3868 12.8452 16.6666 12.5 16.6666C12.1548 16.6666 11.875 16.3868 11.875 16.0416V3.95831C11.875 3.61314 12.1548 3.33331 12.5 3.33331Z",
		fill: "currentColor"
	})
});
export default SvgPauseLine;
